import React, { useEffect } from 'react';
import styles from './GlobalAlert.module.scss';
import { Alert } from 'esa-ui-library';
import { debounce, useStore } from '../../../common';

const GlobalAlert = (): JSX.Element => {
	const [{ globalErrors, globalSuccess }, dispatch] = useStore();

	useEffect(() => {
		if (globalErrors?.length || globalSuccess) debounce(() => dispatch('MESSAGE_INVALIDATE'), 5000);
	}, [globalErrors, globalSuccess]);

	return (
		(globalErrors?.length || globalSuccess) && (
			<section className={styles.GlobalAlert}>
				<Alert text={globalErrors?.join('\r\n') || globalSuccess} danger={!!globalErrors?.length} />
			</section>
		)
	);
};

export { GlobalAlert };
